export default __webpack_public_path__ + "static/media/villarrica-lake--island-birdview.b13bb798.jpg";